<template>
    <b-modal
        id="bv-modal-notification"
        size="md"
        :title="isEditing ? 'Editar notificação' : 'Adicionar notificação'"
        scrollable
        centered
        no-stacking
    >
        <b-container fluid>
            <form id="notification-form">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="notification-event">
                                Evento <span class="text-danger">*</span>
                            </label>
                            <select
                                id="notification-event"
                                class="form-control"
                                v-model="form.event"
                            >
                                <option value="">Selecione um evento...</option>
                                <option
                                    v-for="evt in eventOptions"
                                    :key="evt.value"
                                    :value="evt.value"
                                >{{ evt.label }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="isScheduled">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="notification-time">
                                Horário <span class="text-danger">*</span>
                            </label>
                            <select
                                id="notification-time"
                                class="form-control"
                                v-model="form.scheduleTime"
                            >
                                <option value="">Selecione um horário...</option>
                                <option
                                    v-for="time in timeOptions"
                                    :key="time.value"
                                    :value="time.value"
                                >{{ time.label }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Grupos que recebem a notificação</label>
                            <div class="groups-box">
                                <div class="groups-search">
                                    <input
                                        type="text"
                                        v-model="searchTerm"
                                        placeholder="Pesquisar grupos..."
                                        class="form-control form-control-sm"
                                    >
                                </div>
                                <div class="groups-list">
                                    <div
                                        v-if="filteredGroups.length === 0"
                                        class="text-muted text-center py-2 small"
                                    >
                                        Nenhum grupo encontrado.
                                    </div>

                                    <div
                                        v-for="group in filteredGroups"
                                        :key="group.id"
                                        class="group-item"
                                    >
                                        <div class="group-left">
                                            <input
                                                class="group-checkbox"
                                                type="checkbox"
                                                :id="`group-${group.id}`"
                                                :value="group.id"
                                                v-model="form.groups"
                                            >
                                            <label :for="`group-${group.id}`" class="group-name">
                                                {{ group.name }}
                                            </label>
                                            <span
                                                class="type-badge"
                                                :class="group.type === 'email' ? 'type-email' : 'type-whatsapp'"
                                            >
                                                <i
                                                    :class="group.type === 'email' ? 'fas fa-envelope' : 'fab fa-whatsapp'"
                                                    class="type-icon"
                                                ></i>
                                                {{ group.type === 'email' ? 'E-mail' : 'WhatsApp' }}
                                            </span>
                                        </div>
                                        <div class="members-wrapper">
                                            <button
                                                type="button"
                                                class="btn-members"
                                                :ref="`btn-members-${group.id}`"
                                                @click.stop="toggleMembers(group)"
                                                :aria-expanded="openMembersId === group.id"
                                            >
                                                <i class="fas fa-users" aria-hidden="true"></i>
                                                {{ group.contacts ? group.contacts.length : 0 }} membros
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="selectedGroups.length > 0" class="selected-badges">
                                <span
                                    v-for="group in selectedGroups"
                                    :key="group.id"
                                    class="sel-badge"
                                    :class="group.type === 'email' ? 'sel-badge-email' : 'sel-badge-whatsapp'"
                                >
                                    <i
                                        :class="group.type === 'email' ? 'fas fa-envelope' : 'fab fa-whatsapp'"
                                        class="badge-icon"
                                    ></i>
                                    {{ group.name }}
                                    <span
                                        class="badge-remove"
                                        @click="removeGroup(group.id)"
                                        title="Remover"
                                    >&times;</span>
                                </span>
                            </div>
                            <small v-else class="text-muted">Nenhum grupo selecionado.</small>
                        </div>
                    </div>
                </div>
            </form>
        </b-container>
        <template #modal-footer>
            <div class="modal-footer-wrapper">
                <button
                    type="submit"
                    class="btn btn-primary"
                    @click.prevent="submitForm"
                    :disabled="loading"
                >
                    <span v-if="loading">
                        <i class="fas fa-spinner fa-pulse"></i> Aguarde...
                    </span>
                    <span v-else>
                        <i class="fas fa-save"></i> Salvar
                    </span>
                </button>
                <button
                    v-if="isEditing"
                    type="button"
                    class="btn btn-danger"
                    @click.prevent="deleteNotification"
                    :disabled="loading"
                >
                    <i class="fas fa-trash-alt"></i> Deletar
                </button>
            </div>
        </template>

        <teleport to="body" v-if="false"></teleport>
    </b-modal>
</template>

<script>
export default {
    name: "NotificationModal",

    data() {
        return {
            loading: false,
            allGroups: [],
            dataEdit: {},
            searchTerm: '',
            openMembersId: null,
            openMembersGroup: null,
            popoverStyle: {},
            form: {
                event: '',
                groups: [],
                scheduleTime: '',
            },
            eventOptions: [
                { value: 'request_in_progress', label: 'Solicitação em andamento' },
                { value: 'request_reopened', label: 'Solicitação reaberta' },
                { value: 'request_closed', label: 'Solicitação fechada' },
                { value: 'status_report', label: 'Status Report' },
                { value: 'monitoring', label: 'Monitoramento' },
            ],
            scheduledEvents: ['status_report', 'monitoring'],
            timeOptions: [
                { value: 8, label: '08h' },
                { value: 12, label: '12h' },
                { value: 17, label: '17h' },
                { value: 21, label: '21h' },
            ],
        };
    },

    computed: {
        isScheduled() {
            return this.scheduledEvents.includes(this.form.event);
        },
        isEditing() {
            return !!(this.dataEdit && this.dataEdit.id);
        },
        filteredGroups() {
            if (!this.searchTerm) return this.allGroups;
            const term = this.searchTerm.toLowerCase();
            return this.allGroups.filter(g => g.name.toLowerCase().includes(term));
        },
        selectedGroups() {
            return this.allGroups.filter(g => this.form.groups.includes(g.id));
        },
    },

    methods: {
        async fetchGroups() {
            try {
                const response = await axios.get('/settings/contacts/groups');
                this.allGroups = response.data;
            } catch (error) {
                console.error(error);
                Swal.fire({ type: 'error', text: 'Falha ao carregar grupos!' });
            }
        },

        toggleMembers(group) {
            if (this.openMembersId === group.id) {
                this.closeMembersPopover();
                return;
            }

            if (!group.contacts || group.contacts.length === 0) return;

            this.openMembersId    = group.id;
            this.openMembersGroup = group;

            this.$nextTick(() => {
                this.positionPopover(group.id);
            });
        },

        positionPopover(groupId) {
            const refKey = `btn-members-${groupId}`;
            const btnArr = this.$refs[refKey];
            const btn    = Array.isArray(btnArr) ? btnArr[0] : btnArr;
            if (!btn) return;

            const rect     = btn.getBoundingClientRect();
            const popover  = document.getElementById('members-popover-fixed');
            if (!popover) return;

            const popH     = popover.offsetHeight || 160;
            const spaceBelow = window.innerHeight - rect.bottom;
            const top = spaceBelow >= popH
                ? rect.bottom + 4
                : rect.top - popH - 4;

            popover.style.top   = top + 'px';
            popover.style.left  = (rect.right - popover.offsetWidth) + 'px';
        },

        closeMembersPopover() {
            this.openMembersId    = null;
            this.openMembersGroup = null;
        },

        removeGroup(groupId) {
            this.form.groups = this.form.groups.filter(id => id !== groupId);
        },

        async openModal(data = null) {
            this.resetForm();
            await this.fetchGroups();
            if (data) {
                this.dataEdit = data;
                this.loadFormData(data);
            }
            this.$bvModal.show('bv-modal-notification');
            this.$nextTick(() => {
                document.addEventListener('click', this.handleOutsideClick);
            });
        },

        closeModal(data = null) {
            this.loading = false;
            this.resetForm();
            document.removeEventListener('click', this.handleOutsideClick);
            if (data) this.$emit('updateTable', data);
            this.$bvModal.hide('bv-modal-notification');
        },

        handleOutsideClick(e) {
            const popover = document.getElementById('members-popover-fixed');
            if (popover && popover.contains(e.target)) return;
            const refKey = `btn-members-${this.openMembersId}`;
            const btnArr = this.$refs[refKey];
            const btn    = Array.isArray(btnArr) ? btnArr[0] : btnArr;
            if (btn && btn.contains(e.target)) return;
            this.closeMembersPopover();
        },

        loadFormData(data) {
            this.form.event = data.event || '';
            this.form.scheduleTime = data.schedule_time || '';
            this.form.groups = data.groups
                ? data.groups.map(g => (typeof g === 'object' ? g.id : g))
                : [];
        },

        resetForm() {
            this.form = { event: '', groups: [], scheduleTime: '' };
            this.searchTerm = '';
            this.dataEdit = {};
            this.openMembersId = null;
            this.openMembersGroup = null;
        },

        validateForm() {
            if (!this.form.event) {
                Swal.fire({ type: 'error', text: "Campo 'Evento' é obrigatório!" });
                return false;
            }
            if (this.isScheduled && !this.form.scheduleTime) {
                Swal.fire({ type: 'error', text: "Campo 'Horário' é obrigatório!" });
                return false;
            }
            return true;
        },

        async deleteNotification() {
            const { value } = await Swal.fire({
                title: 'Deseja deletar esta notificação?',
                text: 'Esta ação não poderá ser desfeita.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim, deletar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#dc3545',
                reverseButtons: true,
                showCloseButton: true,
            });

            if (!value) return;

            this.loading = true;

            try {
                await axios.delete(`/settings/notifications/${this.dataEdit.id}`);
                Swal.fire({ type: 'success', text: 'Notificação deletada com sucesso.' });
                this.$emit('deleteNotification', this.dataEdit.id);
                this.closeModal();
            } catch (error) {
                console.error(error);
                const message = error.response?.data?.error || 'Falha ao deletar notificação!';
                Swal.fire({ type: 'error', text: message });
                this.loading = false;
            }
        },

        async submitForm() {
            if (!this.validateForm()) return;
            this.loading = true;

            const formData = {
                event:  this.form.event,
                groups: this.form.groups,
                schedule_time: this.isScheduled ? this.form.scheduleTime : null
            };

            try {
                let response;
                if (this.dataEdit.id) {
                    response = await axios.put(`/settings/notifications/${this.dataEdit.id}`, formData);
                    Swal.fire({ type: 'success', text: 'Notificação atualizada com sucesso.' });
                } else {
                    response = await axios.post('/settings/notifications', formData);
                    Swal.fire({ type: 'success', text: 'Notificação salva com sucesso.' });
                }
                this.closeModal(response.data);
            } catch (error) {
                console.error(error);
                const errors = error.response?.data?.errors;
                let message  = 'Falha ao salvar notificação! Valide os campos e tente novamente.';

                if (errors) {
                    // Laravel 422: { errors: { field: ['msg'] } }
                    if (errors.event) {
                        message = errors.event[0];
                    } else {
                        message = Object.values(errors).flat().join('\n');
                    }
                } else if (error.response?.data?.error) {
                    message = error.response.data.error;
                }

                Swal.fire({ type: 'error', title: 'Atenção', text: message });
                this.loading = false;
            }
        },

        initials(name) {
            if (!name) return '?';
            return name.trim().split(/\s+/).slice(0, 2).map(w => w[0].toUpperCase()).join('');
        },

        memberContact(member, groupType) {
            if (!member.contact) return '';
            if (groupType === 'whatsapp') {
                // formata como telefone se for só dígitos
                const d = String(member.contact).replace(/\D/g, '');
                if (d.length === 11) return d.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
                if (d.length === 10) return d.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
            }
            return member.contact;
        },
    },

    mounted() {
        // Cria o popover fixo no body na montagem do componente
        if (!document.getElementById('members-popover-fixed')) {
            const el = document.createElement('div');
            el.id = 'members-popover-fixed';
            el.style.cssText = [
                'position:fixed',
                'z-index:9999',
                'background:#fff',
                'border:1px solid #ced4da',
                'border-radius:6px',
                'padding:10px 12px',
                'min-width:210px',
                'max-width:300px',
                'box-shadow:0 4px 16px rgba(0,0,0,0.13)',
                'display:none',
                'pointer-events:auto',
            ].join(';');
            document.body.appendChild(el);
        }
    },

    watch: {
        openMembersGroup(group) {
            const el = document.getElementById('members-popover-fixed');
            if (!el) return;

            if (!group || !group.contacts || !group.contacts.length) {
                el.style.display = 'none';
                el.innerHTML = '';
                return;
            }

            const isEmail = group.type === 'email';
            const avatarBg    = isEmail ? '#f8d7da' : '#d4edda';
            const avatarColor = isEmail ? '#721c24' : '#155724';

            const rows = group.contacts.map(m => {
                const ini  = this.initials(m.name);
                const info = this.memberContact(m, group.type);
                return `
                    <div style="display:flex;align-items:center;gap:8px;padding:4px 0;font-size:0.82em;color:#495057;border-top:1px solid #f0f0f0">
                        <span style="display:inline-flex;align-items:center;justify-content:center;width:24px;height:24px;border-radius:50%;background:${avatarBg};color:${avatarColor};font-size:0.7em;font-weight:600;flex-shrink:0">${ini}</span>
                        <div style="min-width:0">
                            <div style="font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${m.name}</div>
                            ${info ? `<div style="font-size:0.88em;color:#6c757d;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${info}</div>` : ''}
                        </div>
                    </div>`;
            }).join('');

            el.innerHTML = `
                <div style="font-size:0.72em;font-weight:600;color:#6c757d;text-transform:uppercase;letter-spacing:0.05em;margin-bottom:6px">Membros</div>
                ${rows}
            `;
            el.style.display = 'block';

            this.$nextTick(() => this.positionPopover(group.id));
        },
    },

    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick);
        const el = document.getElementById('members-popover-fixed');
        if (el) el.remove();
    },
};
</script>

<style scoped>
/* ── Grupos: caixa com busca + lista ── */
.groups-box {
    border: 1px solid #ced4da;
    border-radius: 4px;
    overflow: hidden;
}

.groups-search {
    padding: 8px 10px;
    border-bottom: 1px solid #e9ecef;
    background: #f8f9fa;
}

.groups-list {
    max-height: 200px;
    overflow-y: auto;
    /* overflow-x NÃO é hidden para não cortar popover lateral */
}

.group-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 7px 12px;
    transition: background 0.1s;
}

.group-item:hover {
    background: #f8f9fa;
}

.group-item + .group-item {
    border-top: 1px solid #f0f0f0;
}

.group-left {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 0;
}

.group-checkbox {
    flex-shrink: 0;
    width: 15px;
    height: 15px;
    cursor: pointer;
    accent-color: #1c869a;
}

.group-name {
    font-size: 0.875rem;
    margin-bottom: 0;
    cursor: pointer;
    color: #212529;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Badges de tipo na lista */
.type-badge {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 1px 7px;
    border-radius: 20px;
    font-size: 0.72em;
    font-weight: 500;
    flex-shrink: 0;
}

.type-whatsapp {
    background-color: #d4edda;
    color: #155724;
}

.type-email {
    background-color: #f8d7da;
    color: #721c24;
}

.type-icon {
    font-size: 0.85em;
}

/* Botão membros */
.members-wrapper {
    flex-shrink: 0;
    margin-left: 8px;
}

.btn-members {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    font-size: 0.75em;
    border: 1px solid #ced4da;
    border-radius: 20px;
    background: transparent;
    color: #6c757d;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.1s;
}

.btn-members:hover {
    background: #f0f0f0;
}

/* Badges dos grupos selecionados */
.selected-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-top: 10px;
}

.sel-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 9px;
    border-radius: 20px;
    font-size: 0.78em;
    font-weight: 500;
}

.sel-badge-whatsapp {
    background-color: #d4edda;
    color: #155724;
}

.sel-badge-email {
    background-color: #f8d7da;
    color: #721c24;
}

.badge-icon {
    font-size: 0.85em;
}

.badge-remove {
    cursor: pointer;
    font-size: 1em;
    line-height: 1;
    opacity: 0.7;
    margin-left: 2px;
}

.badge-remove:hover {
    opacity: 1;
}

/* Footer do modal */
.modal-footer-wrapper {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    width: 100%;
}
</style>